<div class="custom-toolbar">
  <div class="custom-toolbar-subdivision-left custom-toolbar-element">
    <yo-button
      iconClass="fa fa-plus"
      [theme]="ButtonThemeEnum.ADD"
      label="CRÉER"
      (onClick)="openDialogEdition(null)"
      tooltip="Créer une fermeture ponctuelle">
    </yo-button>
  </div>
  <div class="custom-toolbar-subdivision-right">
    <div class="custom-button-container">
      <yo-button
        iconClass="fas fa-trash"
        [theme]="ButtonThemeEnum.DELETE"
        (onClick)="deleteValues()"
        [disabled]="!canDelete()"
        tooltip="Supprimer les éléments sélectionnés">
      </yo-button>
    </div>
  </div>
</div>

<dx-data-grid
  keyExpr="id"
  class="data-grid"
  [dataSource]="data"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [allowColumnResizing]="true"
  [showRowLines]="true"
  [showBorders]="true"
  [(selectedRowKeys)]="selectedRows"
  columnResizingMode="widget"
  #grid>
  <dxo-selection
    selectAllMode="allPages"
    showCheckBoxesMode="always"
    mode="multiple"
  ></dxo-selection>
  <dxi-column dataField="id" caption="Actions"
              [width]="79"
              [allowFiltering]="false"
              [allowGrouping]="false"
              cellTemplate="actionsCellTemplate">
  </dxi-column>
  <dxi-column dataField="libelle" caption="Libellé"
              [filterOperations]="['contains']"
              [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="dateFermeture" caption="Date fermeture"
              dataType="string"
              [allowFiltering]="false"
              [allowGrouping]="false"
              [allowSearch]="false"
              cellTemplate="dateTemplate">
  </dxi-column>

  <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
    <yo-button size="small"
                    [theme]="ButtonThemeEnum.DEFAULT_INNER"
      (onClick)="openDialogEdition(cell.row.data)"
      [iconClass]="'fa fa-edit'"
      [tooltip]="'Modifier la fermeture ponctuelle'">
    </yo-button>
  </div>

  <div *dxTemplate="let cell of 'dateTemplate'">
    {{ utilsSvc.customFormatDate(cell?.row.data.dateFermeture, utilsSvc.findDateFormat(cell?.row.data.dateFermeture), "DD/MM") }}
  </div>

  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-sorting mode="multiple"></dxo-sorting>

  <dxo-pager
    [showPageSizeSelector]="true"
    [showNavigationButtons]="false"
    [allowedPageSizes]="[20, 50, 100, 200]"
    [visible]="true"
    [showInfo]="true"
    infoText="{2} éléments facturables">
  </dxo-pager>

</dx-data-grid>

<yo-up-fermetures-ponctuelles-edition-dialog [uniteProduction]="uniteProduction"></yo-up-fermetures-ponctuelles-edition-dialog>
